import React, { useState, useEffect } from "react";
import CssTransition from "../layout/css-transition";
import "../../css/theme.css";
import swal from "@sweetalert/with-react";
import CustomeModal from "../modal-popup/customeModal";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../redux/actions/user";
import {
  transferActivityRequest,
  sendBackToAdminRequest,
} from "../../redux/actions/overview";
import Select, { components } from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RESET_SAVE_TEMPORARY_DATA,
  SAVE_TEMPORARY_DATA,
} from "../../redux/constants";
import { Super_Admin } from "../../constant/AuthenticationConstant";
const { MenuList } = components;

function TransferActivityModal({
  modalOpen,
  setModalOpen,
  mappingid,
  updateTable,
  setUpdateTable = console.log,
  activityId,
  activity_assignment_id,
  company_id,
  email_id,
  isEmbedded,
}) {
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState("");
  const [valueError, setValueError] = useState("");
  const [remark, setRemark] = useState("");
  const [remarkError, setRemarkError] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();
  const { company, id, email, type } = useSelector((state) => state.auth);
  const { userData } = useSelector((state) => state.user);
  const { saveData, tempPageName } = useSelector(
    (state) => state.tempWindowsData
  );
  const navigate = useNavigate();
  const getUser = () => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Unable to transfer To Do. Please try later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getUserData(request));
  };

  useEffect(() => {
    if (modalOpen) {
      getUser();
    }
  }, [modalOpen]);

  useEffect(() => {
    if (userData?.length > 0) {
      let list = [];
      userData.map((item) => {
        if (item.id !== id && item.type === "user")
          list.push({
            value: item.id,
            label: item.name,
            email: item.email,
          });
      });
      setOptions(list);
    }
  }, [userData]);

  const clickcancel = () => {
    setModalOpen(!modalOpen);
    setValue("");
    setRemark("");
    dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
  };

  useEffect(() => {
    if (tempPageName === "Transfer To Do") {
      setModalOpen(true);
      setValue(saveData?.user || "");
      setRemark(saveData?.description || "");
    }
  }, [tempPageName, saveData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value === "") {
      return setValueError("Please select user for transfer activity request.");
    }
    if (remark === "" || remark.length < 5) {
      return setRemarkError(
        "Please provide atleast 5 characters for transfer activity request."
      );
    }

    const payload = {
      activity_assignment_mapping_id:
        mappingid ?? saveData?.activity_assignment_mapping_id,
      user_id: value.value,
      user_email: null,
      request_user_email: !isEmbedded ? email : email_id,
    };

    const request = {
      body: payload,
      onError: () => {
        setModalOpen(false);
        setValue("");
        setRemark("");
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Unable to transfer To Do. Please try later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onSuccess: (data) => {
        setModalOpen(false);
        setValue("");
        setRemark("");
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`To Do successfully transfer to selected user.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });

        // setUpdateTable(updateTable + 1);
      },
    };
    if (tempPageName === "Transfer To Do") {
      dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
    }
    dispatch(transferActivityRequest(request));
  };

  const dropping = (e) => {
    setValueError("");
    setValue(e);
  };

  const Send_back_admin_function = async () => {
    if (remark === "" || remark.length < 5) {
      return setRemarkError(
        "Please provide atleast 5 characters for send back to admin request."
      );
    }

    const payload = {
      activity_id: activityId,
      activity_assignment_id: activity_assignment_id,
      assignment_mapping_id: mappingid,
      request_from: !isEmbedded
        ? id
        : userData.filter((item) => item.email === email_id).length > 0
        ? userData.filter((item) => item.email === email_id)[0].id
        : "",
      type: "Back to Admin",
      description: remark,
    };

    const request = {
      body: payload,
      onError: () => {
        setModalOpen(false);
        setValue("");
        setRemark("");
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Unable to create revert to admin request. Please try later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onSuccess: (data) => {
        if (typeof data === "string") {
          setModalOpen(false);
          setValue("");
          setRemark("");
          return swal({
            content: (
              <CustomeModal type="info" title="Information!" content={data} />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
        setModalOpen(false);
        setValue("");
        setRemark("");
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Revert to admin request successfully created.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(sendBackToAdminRequest(request));
  };

  const handleNavigate = () => {
    const formValues = {
      description: remark,
      user: value,
      activity_assignment_mapping_id:
        mappingid ?? saveData?.activity_assignment_mapping_id,
      user_id: value.value,
      user_email: null,
      request_user_email: !isEmbedded ? email : email_id,
      company_id: !isEmbedded ? company.id : company_id,
    };
    const payload = {
      path: location.pathname,
      tempPageName: "Transfer To Do",
      saveData: formValues,
    };
    dispatch({ type: SAVE_TEMPORARY_DATA, payload });
    navigate("/users", { state: true });
  };

  const CustomMenuList = ({ children, ...props }) => (
    <MenuList {...props}>
      {children}
      <div
        className="menu-list"
        onClick={(e) => {
          e.stopPropagation();
          handleNavigate();
        }}
      >
        <i
          class="fa-solid fa-plus fa-xs"
          style={{ paddingRight: "2px", paddingTop: "2px" }}
        ></i>
        Create New User
      </div>
    </MenuList>
  );

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div className="bg-white overflow-auto max-w-lg w-full max-h-full rounded shadow-lg flex flex-col">
          <div className="py-8 px-6 w-full flex-auto">
            <h3 class="text-lg text-black  leading-6 flex justify-center my-4">
              Transfer To Do
            </h3>
            <div className="flex flex-col mb-4 relative">
              <label
                htmlFor="subject"
                className="font-inter font-medium text-sm leading-5 text-gray-700 mb-1"
              >
                Select User<sup className="text-rose-500 text-xs">*</sup>
              </label>
              <Select
                className="basic-single text-sm unresetText"
                classNames={{
                  control: (style) => {
                    return `!border !shadow-sm ${
                      style.isFocused
                        ? "!border-[--bg-color-300]/50"
                        : "!border-slate-200 hover:!border-gray-300"
                    }`;
                  },
                  container: (style) => {
                    return "!h-[37.5px] !font-inter !text-sm";
                  },
                  menuList: (style) => {
                    return `!max-h-[200px]`;
                  },
                }}
                classNamePrefix="select"
                placeholder="Select User"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                isClearable
                options={options}
                value={value}
                onChange={dropping}
                components={
                  !isEmbedded
                    ? type === Super_Admin
                      ? { MenuList: CustomMenuList }
                      : {}
                    : {}
                }
              />
              {valueError !== "" && (
                <div className="text-rose-500 font-inter font-extralight text-xs pt-1">
                  {valueError}
                </div>
              )}
            </div>
            <div className="flex flex-col mb-4 relative">
              <label
                htmlFor="subject"
                className="font-inter font-medium text-sm leading-5 text-gray-700 mb-1"
              >
                Remarks<sup className="text-rose-500 text-xs">*</sup>
              </label>
              <textarea
                rows={5}
                value={remark}
                onChange={(e) => {
                  setRemarkError("");
                  setRemark(e.target.value);
                }}
                type="text"
                className="form-input p-2 w-full disabled:border-slate-200 resize-none"
              />
              {remarkError !== "" && (
                <div className="text-rose-500 font-inter font-extralight text-xs pt-1">
                  {remarkError}
                </div>
              )}
            </div>

            <form class="w-full my-2" onSubmit={handleSubmit}>
              <div class="px-2 w-full flex justify-between space-x-2">
                <button
                  className="w-full btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 rounded-md text-sm px-5 py-2.5"
                  type="button"
                  onClick={clickcancel}
                >
                  Cancel
                </button>
                <button
                  className="w-full btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white rounded-md text-sm px-5 py-2.5"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
            <div className="mt-6">
              <p
                onClick={Send_back_admin_function}
                className="font-normal text-sm text-center leading-5 text-rose-500 underline cursor-pointer"
              >
                Send TO DO back to admin
              </p>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default TransferActivityModal;
